import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { HugeiconsIcon } from "@hugeicons/react";
import { Alert02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { ConfirmDialog } from "@outpave/ds";
import { AstradaConnection } from "./types";

export interface DisconnectProgramDialogProps {
  open: boolean;
  /** Null while nothing is selected, so the dialog can stay mounted to animate out. */
  connection: AstradaConnection | null;
  onClose: () => void;
  onConfirm: () => void;
  disconnecting: boolean;
}

/**
 * Confirms disconnecting a card program. Uses `ConfirmDialog` with `danger`
 * so the confirm button renders the filled danger style.
 */
const DisconnectProgramDialog: React.FC<DisconnectProgramDialogProps> = ({
  open,
  connection,
  onClose,
  onConfirm,
  disconnecting,
}) => {
  const { t } = useTranslation();

  if (!connection) return null;

  return (
    <ConfirmDialog
      open={open}
      title={t("DisconnectProgramTitle")}
      confirmLabel={t("Disconnect program")}
      busy={disconnecting}
      onConfirm={onConfirm}
      onCancel={onClose}
      tone="danger"
      icon={<HugeiconsIcon icon={Alert02Icon} />}
      message={
        <Trans
          i18nKey="DisconnectProgramMessage"
          components={{ strong: <strong /> }}
          values={{
            programName: connection.name,
            count: connection.cardCount,
          }}
        />
      }
    />
  );
};

export default DisconnectProgramDialog;
